import { createTheme } from '@mui/material/styles'

const CustomTheme = createTheme({
  palette: {
    background: {
      default: '#F8F8F8'
    },
    primary: {
    // light: will be calculated from palette.primary.main,
      main: '#143B6B'
    // dark: will be calculated from palette.primary.main,
    // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      light: '#8ca1bb',
      main: '#538fda',
      // dark: will be calculated from palette.secondary.main,
      contrastText: '#101e2f'
    },
    muted: {
      main: '#8C8C8C'
    },
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: 3,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: 0.2
  },
  overrides: {
    MuiTableHead: {
      root: {
        height: '50px'
      }
    },
    MuiTableCell: {
      root: {
        '&.MuiTableCell-head': {
          fontWeight: 600,
          fontSize: '12px',
          color: 'black',
          textTransform: 'uppercase'
        }
      }
    },
    MuiDataGrid: {
      root: {
        height: '75vh',
        '& .MuiDataGrid-columnsContainer': {
          flexDirection: 'row'
        },
        '& .MuiDataGrid-row.Mui-odd:not(:hover)': {
          backgroundColor: '#F4F8FC'
        },
        '& .MuiDataGrid-columnHeaderTitle, .MuiDataGrid-cell': {
          overflow: 'auto',
          overflowWrap: 'break-word',
          padding: '0.25em',
          maxHeight: 'fit-content!important',
          whiteSpace: 'initial!important',
          lineHeight: '16px!important',
          display: 'flex!important',
          alignItems: 'center',

          '& > div': {
            padding: '0.25em',
            alignSelf: 'stretch',
            maxHeight: 'inherit',
            width: '100%',
            whiteSpace: 'initial',
            lineHeight: '16px'
          }
        }
      }
    }
  }
})

export default CustomTheme
